function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8333 16.5V3.16667C14.8333 2.72464 14.6577 2.30072 14.3452 1.98816C14.0326 1.67559 13.6087 1.5 13.1667 1.5H4.83333C4.39131 1.5 3.96738 1.67559 3.65482 1.98816C3.34226 2.30072 3.16667 2.72464 3.16667 3.16667V16.5M14.8333 16.5H3.16667M14.8333 16.5H16.5M14.8333 16.5H10.6667M3.16667 16.5H1.5M3.16667 16.5H7.33333M10.6667 16.5V12.3333C10.6667 12.1123 10.5789 11.9004 10.4226 11.7441C10.2663 11.5878 10.0543 11.5 9.83333 11.5H8.16667C7.94565 11.5 7.73369 11.5878 7.57741 11.7441C7.42113 11.9004 7.33333 12.1123 7.33333 12.3333V16.5M10.6667 16.5H7.33333M6.5 4.83333H7.33333M6.5 8.16667H7.33333M10.6667 4.83333H11.5M10.6667 8.16667H11.5",
  stroke: "#9CA3AF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgAddressIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/address-icon.3c5fd479.svg";
export { ForwardRef as ReactComponent };